import { Modal } from '@shared/components/Modal';
import { useModal } from '../contexts/ModalContext';

/**
 * ModalRenderer
 *
 * Renders app-level confirm and alert modals driven by ModalContext.
 * Uses the shared Modal component for consistent backdrop, escape-key, and theme-aware styling.
 */
export function ModalRenderer() {
  const { isConfirmOpen, confirmOptions, resolveConfirm, isAlertOpen, alertOptions, dismissAlert } = useModal();

  return (
    <>
      {/* Confirm Modal */}
      <Modal
        isOpen={isConfirmOpen && !!confirmOptions}
        onClose={() => resolveConfirm(false)}
        title={confirmOptions?.title}
        maxWidth="500px"
      >
        <div className="p-4">
          <p className="m-0 mb-4 leading-relaxed text-text whitespace-pre-line">{confirmOptions?.message}</p>
          <div className="flex justify-end gap-2">
            <button className="btn-secondary" onClick={() => resolveConfirm(false)}>
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-danger text-white rounded-md hover:opacity-90 transition-opacity font-medium text-sm"
              onClick={() => resolveConfirm(true)}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>

      {/* Alert Modal */}
      <Modal
        isOpen={isAlertOpen && !!alertOptions}
        onClose={dismissAlert}
        title={alertOptions?.title}
        maxWidth="450px"
        className={alertOptions?.type === 'error' ? 'border-t-2 border-danger' : ''}
      >
        <div className="p-4">
          <p className={`m-0 leading-relaxed whitespace-pre-line ${alertOptions?.type === 'error' ? 'text-danger' : 'text-text'}`}>
            {alertOptions?.message}
          </p>
          <div className="flex justify-end mt-4">
            <button className="btn-primary" onClick={dismissAlert}>
              OK
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
